<!--begin Why SingX section -->
<section id="features" [attr.class]="isMobile ? 'section-bg-3 bg-3 pd50-0' : 'section-bg-3 bg-3'">

    <!--begin container -->
    <div class="container">

        <!--begin row -->
        <div class="row">

            <!--begin col-md-12-->
            <div class="col-md-12 text-center pb-3">

                <h3 class="section-title mb-5 whysingx">Why SingX?</h3>
                <!--begin row -->
                <div class="row">
                    <!--begin col-md-4 -->
                    <div class="col-md-4">
                        <div class="main-services whySingx bg-white rounded"
                            [attr.data-aos]="isMobile ? 'fade-up' : 'fade-left'" data-aos-duration="1000">
                            <i class="icon-bg-1 far fa-chart-bar"></i>
                            <h4>Better Rates than Banks</h4>
                            <p>We offer live exchange rates with no mark ups and only charge a
                                nominal fee shown to you
                                upfront.
                            </p>
                        </div>
                    </div>
                    <!--end col-md-4 -->
                    <!--begin col-md-4 -->
                    <div class="col-md-4">
                        <div class="main-services whySingx bg-white rounded" [attr.data-aos]="'fade-up'"
                            data-aos-duration="2000">
                            <i class="icon-bg-2 fas fa-exchange-alt"></i>
                            <h4>Same-Day Transfers</h4>
                            <p>Your recipient will typically receive the money within a day. View
                                details on <a routerLink="/country-details">country coverage</a>.
                                <!-- <a routerLink="/faq">FAQ</a> -->
                            </p>
                        </div>
                    </div>
                    <!--end col-md-4 -->
                    <!--begin col-md-4 -->
                    <div class="col-md-4">
                        <div class="main-services whySingx bg-white rounded"
                            [attr.data-aos]="isMobile ? 'fade-up' : 'fade-right'" data-aos-duration="1000">
                            <i class="icon-bg-3 fas fa-certificate"></i>
                            <h4>Top-Rated Customer Service</h4>
                            <p>With a Google Rating of 4.5/5 Stars, our customer support team is highly experienced and
                                would be delighted to assist you.</p>
                        </div>
                    </div>
                    <!--end col-md-4 -->
                </div>
                <!--end row -->

            </div>
            <!--end col-md-12 -->

        </div>
        <!--end row -->
        <!--begin row -->
        <div class="row">
            <!--begin col-md-4 -->
            <div class="col-md-4">
                <div class="main-services whySingx bg-white rounded"
                    [attr.data-aos]="isMobile ? 'fade-up' : 'fade-left'" data-aos-duration="1000">
                    <i class="icon-bg-4 fa fa-drivers-license"></i>
                    <h4>Licensed and Regulated</h4>
                    <p *ngIf="country == 'sg'">Based in one of the world's most respected financial hubs, we are
                        licensed by
                        the Monetary Authority of Singapore.</p>
                    <p *ngIf="country == 'au'">In Australia, we are licensed by the Australian Securities & Investments
                        Commission (ASIC).</p>
                    <p *ngIf="country == 'hk'">Based in one of the world's most respected financial hubs, we are
                        regulated as a remittance business by Customs and Excise
                        office in Hong Kong.
                    </p>
                </div>
            </div>
            <!--end col-md-4 -->
            <!--begin col-md-4 -->
            <div class="col-md-4">
                <div class="main-services whySingx bg-white rounded" data-aos="fade-up" data-aos-duration="2000">
                    <i class="icon-bg-5 fas fa-user-lock"></i>
                    <h4>Authentication at Every Step</h4>
                    <p>We use the most advanced systems that technology has to offer to protect your
                        privacy and money.</p>
                </div>
            </div>
            <!--end col-md-4 -->
            <!--begin col-md-4 -->
            <div class="col-md-4">
                <div class="main-services whySingx bg-white rounded"
                    [attr.data-aos]="isMobile ? 'fade-up' : 'fade-right'" data-aos-duration="1000">
                    <i class="icon-bg-6 fas fa-users"></i>
                    <h4>Trusted & Experienced Team</h4>
                    <p>We are a team of payment and technology professionals with many years of
                        experience in banking and finance.</p>
                </div>
            </div>
            <!--end col-md-4 -->
        </div>
        <!--end row -->
    </div>
    <!--end container -->

</section>
<!--end Why SingX section -->